import { render } from "./ReminderNew.vue?vue&type=template&id=6bdca899&scoped=true"
import script from "./ReminderNew.vue?vue&type=script&lang=js"
export * from "./ReminderNew.vue?vue&type=script&lang=js"

import "./ReminderNew.vue?vue&type=style&index=0&id=6bdca899&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdca899"]])

export default __exports__